import axios from "axios";
import {
  branch,
  franchise,
  is_franchise_admin,
  is_franchise_manager,
  is_franchise_staff,
  is_accountant_only,
  url,
} from "../../Functionalities/Config";
import { getToken } from "../../Functionalities/Functions";

// Header and FilterComponent both remount on every page load; websockets push live
// updates after the first paint, so one snapshot per minute per tab is enough.
const CACHE_TTL_MS = 60_000;
const CACHE_KEY = "order_snippet_cache";

let inFlight = null;

const buildQueryParams = () => {
  const keyword = JSON.stringify(["pending", "ongoing", "scheduled", "alert_sound"]);
  let queryParams = `hours=4&keyword=${encodeURIComponent(keyword)}`;
  if (is_franchise_admin || is_franchise_manager || is_franchise_staff) {
    if (franchise && franchise.id) {
      queryParams += `&franchise_id=${franchise.id}`;
    }
  } else if (branch && branch.length > 0 && branch[0].id) {
    queryParams += `&branch_id=${branch[0].id}`;
  }
  return queryParams;
};

export const fetchOrderSnippet = async () => {
  const token = getToken();
  if (!token || token === "no_token" || is_accountant_only) return null;

  const queryParams = buildQueryParams();
  try {
    const cached = JSON.parse(sessionStorage.getItem(CACHE_KEY));
    if (
      cached &&
      cached.queryParams === queryParams &&
      Date.now() - cached.at < CACHE_TTL_MS
    ) {
      return cached.data;
    }
  } catch (e) {}

  if (!inFlight) {
    inFlight = axios
      .get(`${url}/order/ordersnippet/?${queryParams}`, {
        headers: { Authorization: token },
      })
      .then((response) => {
        const data = response && response.data;
        if (!data || (data.Status !== true && data.status !== true)) return null;
        sessionStorage.setItem(
          CACHE_KEY,
          JSON.stringify({ at: Date.now(), queryParams, data })
        );
        return data;
      })
      .finally(() => {
        inFlight = null;
      });
  }
  return inFlight;
};
